<template>
    <div v-if="getheartflag" class="heartanimationbg">
        <BodyMovin
            :src="`https://p3.udn.com.tw/wish/animation/heart/${selectSrc_3('mob', 'pad', 'pc')}/data.json`"
            name="heartanimate"
            :acitve="isactive"
            :loop_flag="false"
            @childYalp="gethide"
        />
    </div>
</template>
<script>
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    import BodyMovin from '@/components/common/bodymovin.vue';
    export default {
        mixins: [selectSrcMethod_3],
        components: {
            BodyMovin
        },
        computed:{
            getheartflag(){
                return this.$store.state.heartflag;
            }
        },
        data(){
            return{
                isactive: true,
            }
        },
        methods:{
            gethide(val){
                this.$store.state.heartflag=val;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .heartanimationbg{
        position: fixed;
        bottom: 0;
        width: 100%;
    }
</style>